<form [formGroup]="formFilter" novalidate class="d-flex flex-row align-items-center month-picker">
  <div class="row align-items-center">
    <label translate class="col-2 col-sm-2 label-custom-from">common_from</label>
    <wsb-month-picker formControlName="from" class="col-10 col-sm-9"></wsb-month-picker>
  </div>
  <div class="row align-items-center">
    <label class="col-2 col-sm-2 label-custom-to" translate>common_to</label>
    <wsb-month-picker formControlName="to" [minDate]="getMinDateForToDateField()" class="col-10 col-sm-10"></wsb-month-picker>
  </div>
</form>
